/** @jsx jsx */
import { Component } from 'react'
import { connect } from 'react-redux'
import { jsx, css } from '@emotion/core'
import { Link } from 'react-router-dom'
import CurrencyValue from './CurrencyValue'

class DashboardItem extends Component {

    renderContent() {
        const { text, stat, icon, is_currency } = this.props

        return (
            <div>
              <div css={ icon_container }>
                <img src={ icon } alt="" css={ icon_css } />
              </div>
              <div css={ children_container }>
                <span css={ stat_container }>
                  { is_currency && <CurrencyValue value={stat || 0} /> }
                  { ! is_currency && <span>{stat || 0}</span> }
                </span>
                <span css={ text_container }>
                  { text }
                </span>
              </div>
            </div>
        )
    }
    
    render() {
        const { background_colour, onClickUrl } = this.props
        return (
            <div css={ [item_container, css`background:${background_colour};`] }>
              { onClickUrl && 
                <Link to={onClickUrl} css={css`color: black`}>
                  { this.renderContent() }
                </Link>
              }
              { ! onClickUrl && this.renderContent() }
            </div>
        )
    }
}
function mapStateToProps(state, props) {
const { background_colour, icon, stat, text } = props
    return {
        background_colour,
        icon,
        stat,
        text,
    }
}
export default connect(mapStateToProps)(DashboardItem)

const item_container = css`
display:flex;
flex-direction: row;
align-items: center;
margin: 20px;
padding: 20px;
border-radius: 10px;
width: 300px;
height: 250px;
max-height: 250px;;
`

const icon_container = css`
display:flex;
flex-direction: column;
align-items: center;
justify-content: center;
padding: 10px;
width: 50%;
`

const children_container = css`
display:flex;
flex-direction: column;
align-items: flex-start;
justify-content: center;
padding: 10px;
`

const icon_css = css`
height: 100px;
width: 100px;
max-height: 100px;
max-width: 100px;
margin-left: 40px;

`

const text_container = css`
font-size: 16px;
`

const stat_container = css`
vertical-align: middle;
font-size: 24px;
letter-spacing: 1.5;
font-weight: 600;
`
